export default __webpack_public_path__ + "static/media/background-1442.a0e993f3.jpg";